import { useState } from 'react';
import { useCreateClientMutation } from '../../../redux/organization/organization.endpoints';
import { Dialog } from 'primereact/dialog';
import { Button } from 'src/components/ui/button';
import { FALLBACK_DEFAULT_CLIENT } from '../../../redux/organization/organization.types';
import { Input } from 'src/components/ui/input';

interface CreateClientModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CreateClientModal = ({ isOpen, onClose }: CreateClientModalProps) => {
  const [clientName, setClientName] = useState('');
  const [createClient, { isLoading }] = useCreateClientMutation();

  const handleSubmit = async(e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createClient({
        title: clientName,
        views: [FALLBACK_DEFAULT_CLIENT],
      }).unwrap();
      setClientName('');
      onClose();
    } catch (error) {
      console.error('Failed to create client:', error);
    }
  };

  const renderFooter = () => (
    <div className="flex justify-end mt-2">
      <Button
        type="submit"
        variant="primary"
        size="lg"
        className="w-full"
        onClick={handleSubmit}
        disabled={isLoading}
      >
        {isLoading ? 'Creating...' : 'Create Client'}
      </Button>
    </div>
  );

  return (
    <Dialog
      visible={isOpen}
      onHide={onClose}
      header={(
        <div className="mb-2 text-lg font-semibold tracking-tight">
          Create New Client
        </div>
      )}
      footer={renderFooter()}
      style={{ width: '90vw', maxWidth: '400px' }}
      contentStyle={{ paddingBottom: 0, paddingLeft: 16, paddingRight: 16 }}
      draggable={false}
      resizable={false}
    >
      <form
        onSubmit={handleSubmit}
        className="flex flex-col w-full"
      >
        <div className="flex flex-col py-2 w-full">
          <Input
            id="title"
            value={clientName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setClientName(e.target.value)}
            placeholder="Client name"
            className="w-full border-gray-400 placeholder:text-gray-700"
          />
        </div>
      </form>
    </Dialog>
  );
};